import type { FieldPack } from '../../../../core/fields/types';
import { FieldType } from '../../../../core/fields/types';

export const orgchartRoleProfileFieldPack: FieldPack = {
  id: 'orgchart-role-profile',
  name: 'Role Profile Fields',
  description: 'Role profile entity fields for new team design - job templates with requirements and leveling',
  version: '1.0.0',
  fields: [
    {
      id: 'name',
      label: 'Role Name',
      type: FieldType.TEXT,
      tags: ['identity'],
      priority: 100,
      required: true,
      sensitivity: 'public',
    },
    {
      id: 'jobCode',
      label: 'Job Code',
      type: FieldType.TEXT,
      tags: ['identity'],
      priority: 95,
      sensitivity: 'internal',
    },
    {
      id: 'jobFamily',
      label: 'Job Family',
      type: FieldType.SELECT,
      allowCustomOptions: true,
      tags: ['role'],
      priority: 90,
      sensitivity: 'public',
    },
    {
      id: 'jobLevel',
      label: 'Level',
      type: FieldType.SELECT,
      allowCustomOptions: true,
      tags: ['role'],
      priority: 85,
      sensitivity: 'public',
    },
    {
      id: 'description',
      label: 'Description',
      type: FieldType.TEXT,
      tags: ['notes'],
      priority: 80,
      multiline: true,
      sensitivity: 'public',
    },
    {
      id: 'responsibilities',
      label: 'Key Responsibilities',
      type: FieldType.TEXT,
      tags: ['role'],
      priority: 75,
      multiline: true,
      sensitivity: 'internal',
    },
    {
      id: 'requiredSkills',
      label: 'Required Skills',
      type: FieldType.MULTI_SELECT,
      tags: ['skills'],
      priority: 70,
      allowCustomOptions: true,
      sensitivity: 'internal',
    },
    {
      id: 'preferredSkills',
      label: 'Preferred Skills',
      type: FieldType.MULTI_SELECT,
      tags: ['skills'],
      priority: 65,
      allowCustomOptions: true,
      sensitivity: 'internal',
    },
    {
      id: 'requiredCertifications',
      label: 'Required Certifications',
      type: FieldType.MULTI_SELECT,
      tags: ['skills', 'compliance'],
      priority: 60,
      allowCustomOptions: true,
      sensitivity: 'internal',
    },
    {
      id: 'requiredEducation',
      label: 'Required Education',
      type: FieldType.SELECT,
      allowCustomOptions: true,
      tags: ['skills', 'education'],
      priority: 55,
      sensitivity: 'internal',
    },
    {
      id: 'experienceYears',
      label: 'Experience Required',
      type: FieldType.NUMBER,
      tags: ['role'],
      priority: 50,
      min: 0,
      sensitivity: 'internal',
    },
    {
      id: 'payGrade',
      label: 'Pay Grade',
      type: FieldType.SELECT,
      allowCustomOptions: true,
      tags: ['compensation'],
      priority: 45,
      sensitivity: 'hr_confidential',
    },
    {
      id: 'careerPathNext',
      label: 'Next Roles',
      type: FieldType.TEXT,
      tags: ['career'],
      priority: 40,
      sensitivity: 'internal',
    },
    {
      id: 'careerPathFrom',
      label: 'Previous Roles',
      type: FieldType.TEXT,
      tags: ['career'],
      priority: 35,
      sensitivity: 'internal',
    },
    {
      id: 'positionCount',
      label: 'Active Positions',
      type: FieldType.NUMBER,
      tags: ['workforce'],
      priority: 30,
      min: 0,
      sensitivity: 'internal',
    },
    {
      id: 'filledCount',
      label: 'Filled',
      type: FieldType.NUMBER,
      tags: ['workforce'],
      priority: 25,
      min: 0,
      sensitivity: 'internal',
    },
    {
      id: 'vacantCount',
      label: 'Vacant',
      type: FieldType.NUMBER,
      tags: ['workforce'],
      priority: 20,
      min: 0,
      sensitivity: 'internal',
    },
  ],
};
